import { combineReducers } from 'redux';

// Import reducers
import table from './article_product_visibility_table_reducer';
import form from './article_product_visibility_form_reducer';

export default combineReducers({ table, form });
